export const createRenameFileUIKey = id => `RENAME_FILE_${id}`;
